unable to read source [project]/nextapp/node_modules/googleapis-common/node_modules/google-logging-utils/src/logging-utils.ts